const { FRONT_CONFIG } = window;

function isMatchedBreakpoint(breakpoint = 'bp_575', mediaQuery = 'max-width') {
  const bp =
    mediaQuery === 'max-width'
      ? FRONT_CONFIG.responsive[breakpoint] - 1
      : FRONT_CONFIG.responsive[breakpoint];
  return window.matchMedia(`(${mediaQuery}: ${bp}px)`).matches;
}

module.exports = {
  matches: isMatchedBreakpoint,
};
